<template>
  <div v-if="showBenefit"
       class="pay-center-benefit-component"
  >
    <ym-item v-if="subsidyInfo.show"
             :title="subsidyInfo.hint"
             :is-link="false"
    >
      <div class="pay-center-benefit-item-save">
        -
        <price :price="subsidyInfo.value"
               :format-free="false"
               size="small"
        />
      </div>
    </ym-item>
    <ym-item v-if="discount.list.length > 0"
             :title="discount.title"
             :is-link="discount.list.length > 1"
             @click="handleChooseBenefit('discount')"
    >
      <div v-if="discount.current"
           class="pay-center-benefit-item-value"
      >
        {{ discount.current.name }}
        <div v-if="discount.save > 0"
             class="pay-center-benefit-item-save"
        >
          -
          <price :price="discount.save"
                 :format-free="false"
                 size="small"
          />
        </div>
      </div>
    </ym-item>
    <ym-item :title="coupon.title"
             :is-link="coupon.list.length > 1"
             @click="handleChooseBenefit('coupon')"
    >
      <div v-if="coupon.current"
           class="pay-center-benefit-item-value"
      >
        {{ coupon.current.name }}
        <div v-if="coupon.save > 0"
             class="pay-center-benefit-item-save"
        >
          -
          <price :price="coupon.save"
                 :format-free="false"
                 size="small"
          />
        </div>
      </div>
    </ym-item>

    <benefit-list-popup :show.sync="showBenefitPopup"
                        :benefits="benefits"
                        :choose="benefitChoose"
                        :target-id="targetId"
                        :target-type="targetType"
                        :show-back="false"
                        :title="benefitPopupTitle"
                        @chose="handleChoseBenefit"
    />
  </div>
</template>

<script>
  import PayCenterItem from '@/pages/Pay/components/PayCenterItem';
  import Price from '@/components/Price';
  import BenefitListPopup from '@/components/BenefitListPopup';
  import { calculatePrice, getCoupons } from '@/services/order';
  import { commonLog } from '@/services/app';
  import { upperCaseFirst } from '@/utils';
  import validator from '@/utils/validator';

  export default {
    name: 'PayCenterBenefit',
    components: {
      'ym-item': PayCenterItem,
      Price,
      BenefitListPopup,
    },
    data() {
      return {
        couponCode: '',
        discount: {
          title: '优惠活动',
          list: [],
          save: 0,
          selected: null,
        },
        coupon: {
          title: '优惠券',
          list: [],
          save: 0,
          selected: null,
        },

        showBenefitPopup: false,
        benefits: [],
        benefitChoose: null,
        benefitPopupTitle: '选择优惠',
      };
    },
    props: {
      targetId: {
        type: Number,
        required: true,
      },
      targetType: {
        type: String,
        required: true,
      },
      targetCount: {
        type: [Number, String],
        required: true,
      },
      price: {
        type: [Number, String],
        required: true,
      },
      amount: {
        type: [Number, String],
        required: true,
      },
      delivery: {
        type: [Number, String],
        required: true,
      },
      discounts: {
        type: Array,
      },
      addressId: {
        type: [Number, String],
        required: true,
      },
      discountSave: Number,
      couponSave: Number,
      subsidyInfo: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      balancePay: {
        validator(val) {
          return validator.isObject(val);
        },
        required: true,
      },
    },
    watch: {
      discounts(val) {
        this.generateList('discount', val);
      },
      discountSave(val) {
        this.discount.save = val;
      },
      couponSave(val) {
        this.coupon.save = val;
      },
    },
    computed: {
      showBenefit() {
        const { discount, coupon, subsidyInfo } = this;
        const { list: discountList } = discount;
        const { list: couponList } = coupon;
        return subsidyInfo || discountList.length > 0 || couponList.length > 0;
      },
    },
    methods: {
      resetData(key) {
        this[key].current = null;
      },
      generateList(key, data) {
        this[key].list = data.map((item) => {
          item.uniqueId = `${item.id}@${key}`;
          return item;
        });
        this.autoClick(key);
      },
      autoClick(key) {
        let firstItem = this[key].list[0];
        // 数据列表为空时，创建ID 为0 的Item，以便后续流程
        if (firstItem == null) {
          firstItem = {
            id: 0,
            uniqueId: `0@${key}`,
          };
        }
        this[`handleChoose${upperCaseFirst(key)}`](firstItem);
      },
      emitChosenEvent() {
        const { coupon, discount } = this;
        const { current: { id: discountIds = 0 } = {} } = discount;
        const { current: { id: couponIds = 0 } = {} } = coupon;
        this.$emit('chosen', {
          couponIds,
          discountIds,
        });
      },
      checkedItem(key, item) {
        // 重置优惠省钱
        this[key].save = 0;
        // 设置选中
        this[key].current = item;
        // 触发事件
        this.emitChosenEvent();
      },
      calculatePrice() {
        return new Promise(async (resolve, reject) => {
          const {
            targetId, targetType, targetCount, discount, coupon, addressId,
          } = this;
          const { current: { id: couponIds } } = coupon;
          const { current: { id: discountIds } } = discount;
          const params = {
            targetId,
            targetType,
            targetCount,
            couponIds,
            discountIds,
            addressId,
          };
          try {
            const data = await calculatePrice(params);
            const { save, shouldPay } = data;
            const { discount: discountSave, coupon: couponSave } = save;
            // 设置价格
            this.discount.save = discountSave;
            this.coupon.save = couponSave;
            const subsidyInfo = {
              show: this.subsidyInfo.show,
              hint: this.subsidyInfo.hint,
              value: data.save.subsidy,
            };
            this.$emit('update:amount', shouldPay);
            this.$emit('update:delivery', data.delivery);
            this.$emit('update:subsidyInfo', subsidyInfo);
            this.$emit('update:balancePay', data.balancePay);
            return resolve();
          } catch (e) {
            commonLog('calculatePriceError', e);
            return reject(e);
          }
        });
      },
      handleChooseCoupon(coupon) {
        // 重置优惠券列表
        this.resetData('coupon');
        // 选中优惠券
        this.checkedItem('coupon', coupon);
        // 计算价格
        this.calculatePrice();
      },
      async handleChooseDiscount(item) {
        // 重置优惠活动列表
        this.resetData('discount');
        const { targetId, targetType } = this;
        // 获取coupons
        const params = {
          targetId,
          targetType,
          discountIds: item.id,
        };
        // 设置选中
        this.checkedItem('discount', item);
        try {
          // 获取可用优惠券
          const data = await getCoupons(params);
          let { coupons } = data;
          if (coupons.length === 0) {
            coupons = [
              {
                desc: '',
                id: -3,
                name: '不使用券码',
                save: 0,
                type: 'notUseCoupon',
              },
            ];
          }
          // 生成可用优惠券列表
          this.generateList('coupon', coupons);
        } catch (e) {
          commonLog('getCouponsError', e);
        }
      },
      handleChooseBenefit(type) {
        const { list } = this[type];
        if (list.length <= 1) return;
        this.benefits = list;
        this.benefitChoose = this[type].current;
        this.benefitPopupTitle = `选择${this[type].title}`;
        this.showBenefitPopup = true;
      },
      handleChoseBenefit(res) {
        const {
          discountIds,
          couponIds,
          name,
          save,
        } = res;
        const type = discountIds !== '' ? 'discount' : 'coupon';
        const id = discountIds !== '' ? Number(discountIds) : Number(couponIds);
        const item = {
          id,
          name,
          save,
          type,
          uniqueId: `${id}@${type}`,
        };

        // 设置选中
        this[`handleChoose${upperCaseFirst(type)}`](item);
      },
    },
    created() {
      const { discounts } = this;
      if (discounts) {
        this.generateList('discount', discounts);
      }
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .pay-center-benefit {
    &-component {
      line-height: 1;
    }

    &-item {
      &-value {
        display: flex;
        align-items: center;
      }

      &-save {
        display: flex;
        align-items: center;
        margin-left: @size-extra-small;
        color: @color-text-highlight;
      }
    }
  }
</style>
